import { FlexiSlider } from "appworks/graphics/elements/flexi-slider";
import { SliderElement } from "appworks/graphics/elements/slider-element";
import { Layers } from "appworks/graphics/layers/layers";
import { ControlFactory } from "appworks/ui/factories/control-factory";
import { AgsCreditSizeLimitSliderControl } from "../ags-credit-size-slider-control";

export class AgsCreditSizeLimitSliderControlFactory implements ControlFactory {
    public filter(layer: Layers): boolean {
        return (
            layer.getSprite("credit_size_slider_track") != null &&
            layer.getSprite("credit_size_slider_fill") != null &&
            layer.getSprite("credit_size_slider_handle") != null &&
            layer.getFlexiText("credit_size_slider_label") != null
        );
    }

    public build(layer: Layers): AgsCreditSizeLimitSliderControl[] {
        const sliderElement = new SliderElement(
            layer,
            layer.getSprite("credit_size_slider_track"),
            layer.getSprite("credit_size_slider_fill"),
            layer.getSprite("credit_size_slider_handle")
        );

        const slider = new FlexiSlider();
        slider.addTarget(sliderElement);

        const label = layer.getFlexiText("credit_size_slider_label");
        const minLabel = layer.getFlexiText("credit_size_slider_min_label");
        const maxLabel = layer.getFlexiText("credit_size_slider_max_label");

        return [new AgsCreditSizeLimitSliderControl(slider, label, minLabel, maxLabel)];
    }
}
